var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var PlusIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M0,12 C0,12.8284271 0.671572875,13.5 1.5,13.5 L10.25,13.5 C10.3880712,13.5 10.5,13.6119288 10.5,13.75 L10.5,22.5 C10.5,23.3284271 11.1715729,24 12,24 C12.8284271,24 13.5,23.3284271 13.5,22.5 L13.5,13.75 C13.5,13.6119288 13.6119288,13.5 13.75,13.5 L22.5,13.5 C23.3284271,13.5 24,12.8284271 24,12 C24,11.1715729 23.3284271,10.5 22.5,10.5 L13.75,10.5 C13.6119288,10.5 13.5,10.3880712 13.5,10.25 L13.5,1.5 C13.5,0.671572875 12.8284271,0 12,0 C11.1715729,0 10.5,0.671572875 10.5,1.5 L10.5,10.25 C10.5,10.3880712 10.3880712,10.5 10.25,10.5 L1.5,10.5 C0.671572875,10.5 0,11.1715729 0,12 Z" })))); };
export var Plus = styled(PlusIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=Plus.js.map